import apiDB from './api_db';

let subscriptions = new apiDB({
    api_module: 'subscriptions',
    table_key_name: 'subscription_id',
    reducer_name: 'subscriptionsR',
    reducer_var: 'subscriptions',
    action_prefix: 'SUBSCRIPTIONS'});

export default subscriptions;